import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Building2, LogIn, Pencil, Trash2 } from "lucide-react";
import { LicencaBadge } from "./LicencaBadge";

export function EmpresasTable({ items, isSuperAdmin, onToggleZapi, onAcessar, onEdit, onDelete }) {
  return (
    <Card>
      <CardHeader><CardTitle>Empresas cadastradas ({items.length})</CardTitle></CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Logo</TableHead><TableHead>Nome</TableHead><TableHead>Slug</TableHead><TableHead>CNPJ</TableHead>
              <TableHead>Segmento</TableHead><TableHead>Telefone</TableHead>
              <TableHead>Licença</TableHead>
              {isSuperAdmin && <TableHead className="text-center">Z-API</TableHead>}
              <TableHead>Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((e) => (
              <EmpresaRow key={e.id} e={e} isSuperAdmin={isSuperAdmin} onToggleZapi={onToggleZapi} onAcessar={onAcessar} onEdit={onEdit} onDelete={onDelete} />
            ))}
            {items.length === 0 && (
              <TableRow><TableCell colSpan={isSuperAdmin ? 9 : 8} className="text-center text-muted-foreground py-6">Nenhuma empresa cadastrada</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

function EmpresaRow({ e, isSuperAdmin, onToggleZapi, onAcessar, onEdit, onDelete }) {
  return (
    <TableRow data-testid={`empresa-row-${e.id}`}>
      <TableCell>
        {e.logo_base64
          ? <img src={e.logo_base64} alt="logo" className="w-10 h-10 object-contain rounded bg-orange-50"/>
          : <div className="w-10 h-10 rounded bg-orange-50 flex items-center justify-center text-orange-600"><Building2 className="w-5 h-5"/></div>}
      </TableCell>
      <TableCell className="font-semibold">{e.nome}</TableCell>
      <TableCell className="mono text-xs text-muted-foreground" data-testid={`empresa-slug-${e.id}`}>
        {e.slug ? <code className="bg-orange-50 px-1.5 py-0.5 rounded">{e.slug}</code> : "—"}
      </TableCell>
      <TableCell className="mono text-xs">{e.cnpj || "—"}</TableCell>
      <TableCell className="text-sm">{e.segmento || "—"}</TableCell>
      <TableCell className="text-sm">{e.telefone || "—"}</TableCell>
      <TableCell><LicencaBadge status={e.license_status} testId={`licenca-badge-${e.id}`} /></TableCell>
      {isSuperAdmin && <TableCell className="text-center"><ZapiToggle e={e} onToggle={onToggleZapi} /></TableCell>}
      <TableCell>
        <div className="flex gap-1">
          {isSuperAdmin && (
            <Button size="sm" variant="outline" onClick={() => onAcessar(e)} data-testid={`btn-acessar-ambiente-${e.id}`}
              title={`Entrar como admin de "${e.nome}" (Modo Suporte)`} className="h-8 border-amber-300 text-amber-700 hover:bg-amber-50 gap-1">
              <LogIn className="w-3.5 h-3.5"/>
              <span className="hidden lg:inline">Acessar</span>
            </Button>
          )}
          <Button size="icon" variant="ghost" onClick={() => onEdit(e)} data-testid={`btn-edit-empresa-${e.id}`}>
            <Pencil className="w-4 h-4 text-orange-600"/>
          </Button>
          <Button size="icon" variant="ghost" onClick={() => onDelete(e)} data-testid={`btn-del-empresa-${e.id}`}>
            <Trash2 className="w-4 h-4 text-rose-600"/>
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}

// Iter 77: kill switch SA-only da Z-API por empresa. null/undefined = ativa (retrocompat).
function ZapiToggle({ e, onToggle }) {
  const ativo = e.zapi_ativo_global !== false;
  return (
    <button type="button" onClick={() => onToggle(e)} data-testid={`toggle-zapi-ativo-${e.id}`} data-active={ativo ? "true" : "false"}
      title={ativo ? "Z-API ATIVA — clique pra desligar gatilhos automáticos" : "Z-API DESLIGADA — clique pra reativar"}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold transition-colors ${
        ativo ? "bg-emerald-100 text-emerald-800 hover:bg-emerald-200 border border-emerald-300" : "bg-slate-100 text-slate-500 hover:bg-slate-200 border border-slate-300"}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${ativo ? "bg-emerald-500 animate-pulse" : "bg-slate-400"}`} />
      {ativo ? "ATIVA" : "OFF"}
    </button>
  );
}
